import { render, staticRenderFns } from "./calligraphySeries.vue?vue&type=template&id=0a031649&scoped=true"
import script from "./calligraphySeries.vue?vue&type=script&lang=ts"
export * from "./calligraphySeries.vue?vue&type=script&lang=ts"
import style0 from "./calligraphySeries.vue?vue&type=style&index=0&id=0a031649&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a031649",
  null
  
)

export default component.exports